(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("platform", [], factory);
	else if(typeof exports === 'object')
		exports["platform"] = factory();
	else
		root["platform"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 